import * as React from "react";
import type { SVGProps } from "react";
const SvgTrash03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M2.4 5.4h19.2M8.4 1.8h7.2m.6 20.4H7.8a2.4 2.4 0 0 1-2.4-2.4L4.852 6.65a1.2 1.2 0 0 1 1.2-1.25h11.897a1.2 1.2 0 0 1 1.199 1.25L18.6 19.8a2.4 2.4 0 0 1-2.4 2.4Z"
    />
  </svg>
);
export default SvgTrash03;
